export enum ProductCategory {
  AdditionalFees = 'additional-fees',
  AdditionalInformation = 'additional-information',
  AdditionalOption = 'additional-option',
  AdditionsAndAdjustments = 'additions-and-adjustments',
  BasePrice = 'base-price',
  DripEdgeColor = 'drip-edge-color',
  Doors = 'doors',
  FixedLayout = 'fixed-layout',
  FlooringInterior = 'flooring-interior',
  Frameouts = 'frameouts',
  GarageDoors = 'garage-doors',
  Other = 'other',
  PorchDeckingColor = 'porch-decking-color',
  PorchRailingColor = 'porch-railing-color',
  PorchColumnColor = 'porch-column-color',
  RollUpDoors = 'roll-up-doors',
  RoofColor = 'roof-color',
  SidingColor = 'siding-color',
  Structure = 'structure',
  Transoms = 'transoms',
  TrimColor = 'trim-color',
  UnknownProductKey1 = 'unknown-product-key1',
  UnknownProductKey2 = 'unknown-product-key2',
  Vents = 'vents',
  Windows = 'windows',
}
